let Handlebars;

let Handlebars_Helper;

Handlebars = require("handlebars");

Handlebars_Helper = (() => {
    function Handlebars_Helper() {
        Handlebars.registerHelper("ifvalue", function(conditional, options) {
            if (options.hash.value === conditional) {
                return options.fn(this);
            } else {
                return options.inverse(this);
            }
        });
    }

    return Handlebars_Helper;
})();

export default new Handlebars_Helper();
